// Delegate to the unified i18n in ../i18n to avoid double initialization
import i18n, {
  FALLBACK_LOCALE,
  localeMetadata,
  loadLanguage as baseLoadLanguage,
  supportedLngs,
  type LocaleCode,
} from '../i18n';

export const SUPPORTED_LANGUAGES = Object.fromEntries(
  supportedLngs.map(code => {
    const meta = localeMetadata[code];
    return [code, {
      name: meta.name,
      nativeName: meta.nativeName,
      flag: meta.flag,
      preview: meta.preview,
    }];
  })
) as Record<LocaleCode, {
  name: string;
  nativeName: string;
  flag: string;
  preview: boolean;
}>;

export type SupportedLanguage = LocaleCode;

export const changeLanguage = async (
  language: SupportedLanguage
): Promise<void> => {
  await baseLoadLanguage(language);
};

export const getCurrentLanguage = (): SupportedLanguage => {
  const code = (i18n.language || FALLBACK_LOCALE).slice(0, 2);
  return (supportedLngs.includes(code) ? code : FALLBACK_LOCALE) as SupportedLanguage;
};

export const isLanguageSupported = (
  language: string
): language is SupportedLanguage => {
  return supportedLngs.includes(language as SupportedLanguage);
};

export default i18n;
